import { render, staticRenderFns } from "./widget_motivational_sentences.vue?vue&type=template&id=c440260a&scoped=true&"
import script from "./widget_motivational_sentences.vue?vue&type=script&lang=js&"
export * from "./widget_motivational_sentences.vue?vue&type=script&lang=js&"
import style0 from "./widget_motivational_sentences.vue?vue&type=style&index=0&id=c440260a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440260a",
  null
  
)

export default component.exports